import BigNumber from 'bignumber.js'
import { getCreatedByName, getModByName } from 'helpers/AuditUserName'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React from 'react'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  mode?: string
}

export const ARGenerateScheduledBillingDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList } = props

  const taxAmt = new BigNumber(listEl?.TaxScheme?.LatestTax?.Rate)
    .dividedBy(100)
    .multipliedBy(listEl?.BillingAmt)
    .toNumber()

  return (
    <>
      <div className="content-wrap left ">
        <div className="desc " style={{ color: 'grey' }}>
          Item
        </div>
        <div className="mdDesc text-noflow">{listEl?.BillItem?.Name}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Billing Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.ScheduledBillingDate)}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Amount
        </div>
        <div className="mdDesc"> {amtStr(listEl?.BillingAmt)} </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Tax Scheme
        </div>
        <div className="mdDesc"> {listEl?.TaxScheme?.Name} </div>
      </div>

      {/* <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Tax Rate
        </div>
        <div className="mdDesc">{`${amtStr(
          listEl?.TaxScheme?.LatestTax?.Rate
        )}`}</div>
      </div> */}

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Tax Amount
        </div>
        <div className="mdDesc"> {amtStr(listEl?.TaxAmt)} </div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Billing Description
        </div>
        <div className="mdDesc"> {listEl?.Description} </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Created Date
        </div>
        <div className="mdDesc">
          {formatDate(listEl?.ScheduledBillingHeader?.createdTs)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Created By
        </div>
        <div className="mdDesc">
          {getCreatedByName(listEl?.ScheduledBillingHeader, userList)}
        </div>
      </div>

      {/* <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.ScheduledBillingHeader?.submittedTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {
            userList?.find(
              user => user.ID == listEl?.ScheduledBillingHeader?.submittedBy
            )?.name
          }
        </div>
      </div> */}

      {listStatus === 'BILLED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Completed Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.ScheduledBillingHeader?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Completed By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {
                userList?.find(
                  user => user.ID == listEl?.ScheduledBillingHeader?.approvedBy
                )?.name
              }
            </div>
          </div>

          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Billed Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.modTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Billed By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {getModByName(listEl, userList)}
            </div>
          </div>
        </>
      )}
    </>
  )
}
